import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { AlertType } from '../../models';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertComponent {
  @HostBinding('class')
  private get classes(): string {
    return `inline-flex min-h-12 flex-row justify-between items-center rounded-md py-2 px-3 gap-3 ${this.getBackgroundClass()} font-main text-white text-base shadow-sm`;
  }

  @HostBinding('attr.data-test-alert-type')
  private get alertTypeAttr(): AlertType {
    return this.alertType;
  }

  @Input()
  alertType: AlertType;

  @Input()
  displayCloseBtn = true;

  @Output()
  closeClick = new EventEmitter<void>();

  private getBackgroundClass(): string {
    switch (this.alertType) {
      case 'success':
        return 'bg-blue-70';
      case 'error':
        return 'bg-pink-90';
      default:
        return '';
    }
  }
}
